import { useState, useEffect } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaWhatsapp,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const ContactUs = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="bg-bodyBgColor relative select-none">
      <div className="min-h-screen">
        {/* Hero Section */}
        <div className="bg-gradient-to-br from-indigo-500 to-darkBgColor text-white py-10 px-5 text-center">
          <h1 className="text-4xl font-bold">📞 Contact Us</h1>
          <p className="mt-3 text-lg">
            Connect with <b>Super Store</b> through our official channels
          </p>

          {/* Social Icons */}
          <div className="flex justify-center gap-4 mt-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              className="text-blue-400 text-2xl p-3 rounded-full bg-white hover:bg-white/30 transition"
            >
              <FaFacebook />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              className="text-orange-500 text-2xl p-3 rounded-full bg-white hover:bg-white/30 transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noreferrer"
              className="text-blue-500 text-2xl p-3 rounded-full bg-white hover:bg-white/30 transition"
            >
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* Contact Cards */}
        <div className="max-w-6xl mx-auto px-5 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition">
            <FaPhoneAlt className="text-indigo-500 text-3xl mx-auto mb-3" />
            <h3 className="text-xl font-semibold mb-2">Call Us</h3>
            <p className="text-gray-600">+880 1XXX-XXXXXX</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition">
            <FaMapMarkerAlt className="text-indigo-500 text-3xl mx-auto mb-3" />
            <h3 className="text-xl font-semibold mb-2">Visit Us</h3>
            <p className="text-gray-600">Dhaka, Bangladesh</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition">
            <FaWhatsapp className="text-indigo-500 text-3xl mx-auto mb-3" />
            <h3 className="text-xl font-semibold mb-2">WhatsApp</h3>
            <p className="text-gray-600">Chat with us instantly</p>
          </div>
        </div>

        {/* Floating WhatsApp Button */}
        <a
          href="https://wa.me/8801XXXXXXXXX" // replace with your WhatsApp number
          target="_blank"
          rel="noreferrer"
          className="fixed bottom-5 right-5 bg-[#25D366] text-white w-14 h-14 rounded-full flex justify-center items-center shadow-lg hover:scale-110 transition-transform z-50"
        >
          <FaWhatsapp size={28} />
        </a>
      </div>
      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="
              fixed bottom-6 right-6
              w-8 h-8 md:w-8 md:h-8
              bg-darkBgColor text-white
              rounded-full
              shadow-lg
              flex items-center justify-center
            "
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default ContactUs;
